import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageStateSelectors } from '../../../../app/page/page-state/page-state.selectors';
import { initialSettingsPage } from '../../../../app/page/settings/settings.actions';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { PageLayout } from '../../common/PageLayout';
import { useHistory, useLocation } from 'react-router-dom';
import { FaDollarSign } from 'react-icons/fa';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { Navigation } from './components/Navigation';
import { GeneralSettingsForm } from './components/GeneralSettingsForm';
import { settingsSelectors } from '../../../../app/resource/settings/settings.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { AnnualAndPeriods } from './components/AnnualsAndPeriods';
import { Integrations } from './components/Integrations';

export const GeneralPage = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const loggedUserisAdmin = useSelector(authSelectors.selectUserIsAdmin);
  const loggedUserId = useSelector(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ? loggedUserId : '');
  const settings = useSelectWithParams(
    settingsSelectors.selectResourceById,
    loggedUser?.tenantId ? loggedUser.tenantId : '',
  );

  // Determine active tab based on current URL
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/annuals-and-periods')) {
      return 'annualsAndPeriods';
    }
    if (path.includes('/general-settings')) {
      return 'generalSettings';
    }
    if (path.includes('/integrations')) {
      return 'integrations';
    }
    return 'generalSettings'; // default
  };

  const handleNavigation = (item: string) => {
    const basePath = '/settings/administration';
    switch (item) {
      case 'annualsAndPeriods':
        history.push(`${basePath}/annuals-and-periods`);
        break;
      case 'generalSettings':
        history.push(`${basePath}/general-settings`);
        break;
      case 'integrations':
        history.push(`${basePath}/integrations`);
        break;
      default:
        history.push(`${basePath}/general-settings`);
    }
  };

  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'settings');

  useEffect(() => {
    dispatch(initialSettingsPage());
  }, [dispatch]);

  return (
    settings && (
      <PageLayout showLoader={showLoader} showHide={true}>
        {!showLoader && (
          <div className="row mb-25">
            <div className="col-12">
              <div className="panel">
                <div className="panel-header no-border">
                  <h2 className="bold">Settings</h2>
                </div>
                <div className="panel-body pt-0 ho-hover">
                  <div className="border-radius-1 lightGray-bg p-2">
                    <div className="row">
                      <div className="col max-250">
                        {loggedUserisAdmin && (
                          <button
                            className="directory-button panel small-panel flex aic px-1 mb-1 active"
                            onClick={() => history.push('/settings/administration')}
                          >
                            <i className="icon-settings mr-1 blueGray" /> Administration
                          </button>
                        )}
                        <button
                          className="directory-button panel small-panel flex aic px-1 mb-1"
                          onClick={() => history.push('/settings/profile')}
                        >
                          <i className="icon-user mr-1 blueGray" /> Profile
                        </button>
                        {loggedUserisAdmin && (
                          <button
                            className="directory-button panel small-panel flex aic px-1 mb-1"
                            onClick={() => history.push('/settings/subscription')}
                          >
                            <FaDollarSign size={14} className="mr-1 blueGray" /> Subscription
                          </button>
                        )}
                      </div>
                      <div className="col">
                        <div className="panel w100">
                          <div className="panel-header no-border">
                            <h2 className="bold">Administration</h2>
                          </div>
                          <div className="panel-body pt-0">
                            <div className="border-radius-1 lightGray-bg p-2">
                              <div className="panel w100 p-3">
                                <div className="row">
                                  <Navigation onNavigationClick={handleNavigation} activeItem={getActiveTab()} />
                                  {getActiveTab() === 'annualsAndPeriods' && <AnnualAndPeriods />}
                                  {getActiveTab() === 'generalSettings' && <GeneralSettingsForm data={settings} />}
                                  {getActiveTab() === 'integrations' && <Integrations settings={settings} />}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </PageLayout>
    )
  );
};
